"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFQ_ROLES = void 0;
var RFQ_ROLES;
(function (RFQ_ROLES) {
    RFQ_ROLES["SEARCH_RFQ"] = "search-rfq";
    RFQ_ROLES["VIEW_RFQ"] = "view-rfq";
    RFQ_ROLES["CREATE_RFQ"] = "create-rfq";
    RFQ_ROLES["MODIFY_RFQ"] = "modify-rfq";
    RFQ_ROLES["MODIFY_RFQ_STATUS"] = "modify-rfq-status";
    RFQ_ROLES["SEARCH_RFQ_FILES"] = "search-rfq-files";
    RFQ_ROLES["VIEW_RFQ_FILE"] = "view-rfq-file";
    RFQ_ROLES["CREATE_RFQ_FILE"] = "create-rfq-file";
    RFQ_ROLES["MODIFY_RFQ_FILE"] = "modify-rfq-file";
    RFQ_ROLES["SEARCH_RFQ_LINES"] = "search-rfq-lines";
    RFQ_ROLES["VIEW_RFQ_LINE"] = "view-rfq-line";
    RFQ_ROLES["CREATE_RFQ_LINE"] = "create-rfq-line";
    RFQ_ROLES["MODIFY_RFQ_LINE"] = "modify-rfq-line";
    RFQ_ROLES["MODIFY_RFQ_LINE_STATUS"] = "modify-rfq-line-status";
    RFQ_ROLES["ASSIGN_RFQ_LINE"] = "assign-rfq-line";
    RFQ_ROLES["DELETE_RFQ_LINE"] = "delete-rfq-line";
})(RFQ_ROLES = exports.RFQ_ROLES || (exports.RFQ_ROLES = {}));
//# sourceMappingURL=request-for-quote.roles.js.map